import { createContext } from 'react';

import { DeviceQueryResult } from '@totem/types/devices';

interface Context {
  loading: boolean;
  deviceId: string;
  deviceData: DeviceQueryResult;
  action: string;
  onAction: (string) => void;
}

export default createContext<Context>({
  loading: false,
  deviceId: '',
  deviceData: null,
  action: '',
  onAction: () => {},
});
